import styled from '@emotion/styled';

export const DetailProgresStyle = styled.div`
  @media (min-width: 481px) and (max-width: 767px) {
    .btn-detail {
      top: 0% !important;
    }
  }

  @media (min-width: 320px) and (max-width: 480px) {   
    .btn-detail {
      top: 0% !important;
    }
  }

  .container-list {
    max-width: 1400px;
    margin-top : 3%;
  }

  .detail-atribut {
    border-bottom: 1px solid #E0E0E0;
    display: inline-flex;
    width: 100%;
    margin-top: 2%;
  }

  .btn-kembali {
    float: left;
  }

  .link-proposal {
    color: #B6B600;
  }
`;
